import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { deleteLightningScenarioAPI } from './api';

const LIGHTNING_SCENARIOS = 'lightningScenarios';

export function useDeleteLightningScenario({ onSuccess }) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL().toLowerCase();

  const { openModal } = useModal();

  const { mutate, isLoading } = useMutation(
    (scenarioId) => deleteLightningScenarioAPI(scenarioId),
    {
      onSuccess: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'success',
            description: 'deleteScenarioSuccess',
          },
        });
        queryClient.invalidateQueries([LIGHTNING_SCENARIOS, tenantId]);
        onSuccess();
      },
      onError: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'deleteScenarioFail',
          },
        });
      },
    },
  );

  return {
    deleteLightningScenario: mutate,
    isLoading,
  };
}
